import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { TRUCK_SHIFT_UPDATE_MUTATION_KEY } from 'src/hooks/useIsTruckShiftUpdating';
import { BulkApplyRequestBody, BulkConflict, parseCheckConflict } from 'src/pages/TruckShifts/bulkSelection';

export const BULK_APPLY_PATH = '/api/v5/truck_shifts/bulk';
export const BULK_APPLY_CHECK_PATH = `${BULK_APPLY_PATH}/check`;

// 反映前の衝突チェック（200・mutation なし）。衝突があれば BulkConflict、無ければ null。
export const checkBulkApplyConflict = async (body: BulkApplyRequestBody): Promise<BulkConflict | null> => {
  const response = await axios.post(BULK_APPLY_CHECK_PATH, body);
  return parseCheckConflict(response.data);
};

export type BulkApplyResult = { created_count: number; deleted_count: number; split_count?: number };

export const useMutationBulkApply = () => useMutation(
  async (body: BulkApplyRequestBody): Promise<BulkApplyResult> => {
    const response = await axios.post<BulkApplyResult>(BULK_APPLY_PATH, body);
    return response.data;
  },
  {
    // 稼働表更新として識別する mutationKey（右下「稼働表を更新中」＋編集ロックが働く）。
    // 成功時の invalidate は App の MutationCache にこの key で集約（画面 unmount 後の完了でも再取得するため）。
    mutationKey: TRUCK_SHIFT_UPDATE_MUTATION_KEY,
  },
);
